import { render, staticRenderFns } from "./AddItemsDocument.vue?vue&type=template&id=1f2aa24b&scoped=true"
import script from "./AddItemsDocument.vue?vue&type=script&lang=js"
export * from "./AddItemsDocument.vue?vue&type=script&lang=js"
import style0 from "./AddItemsDocument.vue?vue&type=style&index=0&id=1f2aa24b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2aa24b",
  null
  
)

export default component.exports